import { Box, Typography, Button } from "@mui/material";
import ShareOutlinedIcon from "@mui/icons-material/ShareOutlined";
import CheckIcon from "@mui/icons-material/Check";
import { CARD_BORDER, GREEN, HOVER_BG, PURPLE, PURPLE_TINT, TEXT_MAIN, TEXT_SUB, g } from "../styles";

const ellipsis = { overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" };

const s = {
  row: {
    display: "flex",
    alignItems: "center",
    gap: "12px",
    padding: "10px 12px",
    border: CARD_BORDER,
    borderRadius: "10px",
    backgroundColor: "#fff",
    minWidth: 0,
    "&:hover": { backgroundColor: HOVER_BG },
  },
  thumbWrap: { position: "relative", width: "56px", minWidth: "56px", height: "56px", borderRadius: "8px", overflow: "hidden", backgroundColor: PURPLE_TINT },
  thumb: { width: "100%", height: "100%", objectFit: "cover", display: "block" },
  // Once shared the row reads as done (V) but stays usable — the manager may
  // still share it on another channel.
  sharedVeil: {
    position: "absolute",
    inset: 0,
    backgroundColor: "rgba(255, 255, 255, 0.6)",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  sharedBadge: {
    width: "22px",
    height: "22px",
    borderRadius: "50%",
    backgroundColor: GREEN,
    color: "#fff",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  text: { flex: 1, minWidth: 0, display: "flex", flexDirection: "column", alignItems: "flex-start", gap: "2px" },
  title: {
    fontSize: "14px",
    fontWeight: 500,
    color: TEXT_MAIN,
    lineHeight: 1.35,
    maxWidth: "100%",
    overflow: "hidden",
    display: "-webkit-box",
    WebkitLineClamp: 2,
    WebkitBoxOrient: "vertical",
  },
  detail: { fontSize: "12px", color: TEXT_SUB, lineHeight: 1.4, maxWidth: "100%", ...ellipsis },
  sharedButton: { color: GREEN, "&:hover": { backgroundColor: HOVER_BG, borderColor: GREEN } },
};

// One shareable thing in the "What to share" column: image, why it's worth
// sharing now, what it is, and the share button.
const ShareCard = ({ item, lang, t, onShare }) => {
  const title = item.title[lang] ?? item.title.en;
  const detail = item.detail[lang] ?? item.detail.en;

  return (
    <Box component="article" sx={s.row}>
      <Box sx={s.thumbWrap}>
        <Box component="img" src={item.image} alt={title} sx={s.thumb} />
        {item.shared && (
          <Box sx={s.sharedVeil}>
            <Box sx={s.sharedBadge}>
              <CheckIcon sx={{ fontSize: 14 }} aria-hidden="true" />
            </Box>
          </Box>
        )}
      </Box>
      <Box sx={s.text}>
        <Box component="span" sx={g.pill(PURPLE, PURPLE_TINT)}>
          {t(`share.occasions.${item.occasion}`)}
        </Box>
        <Typography component="h3" sx={s.title}>{title}</Typography>
        <Typography sx={s.detail}>{detail}</Typography>
      </Box>
      <Button
        variant="outlined"
        size="small"
        onClick={() => onShare(item)}
        startIcon={item.shared ? <CheckIcon sx={{ fontSize: 16 }} /> : <ShareOutlinedIcon sx={{ fontSize: 16 }} />}
        sx={{ ...g.outlineBtn, flexShrink: 0, ...(item.shared ? s.sharedButton : {}) }}
      >
        {item.shared ? t("share.shared") : t("share.share_button")}
      </Button>
    </Box>
  );
};

export default ShareCard;
